@for (item of items(); track item.title) {
  @if (item.validPermission) {
    @if (item.children?.length) {
      <button mat-menu-item [matMenuTriggerFor]="childMenu">
        <mat-icon>{{ item.icon }}</mat-icon>
        <span>{{ item.title }}</span>
      </button>
      <mat-menu #childMenu="matMenu">
        <nav-menu-items
          [items]="item.children"
          (navigate)="navigate.emit($event)" />
      </mat-menu>
    } @else {
      <button mat-menu-item (click)="navigate.emit(item.route!)">
        <mat-icon>{{ item.icon }}</mat-icon>
        <span>{{ item.title }}</span>
      </button>
    }
  }
}
